// extracted by mini-css-extract-plugin
export default {"projectsContainer":"Field_projectsContainer__kBl45"};